module.exports = __webpack_public_path__ + "img/look1.962b3b84.svg";